import React from "react";
import OurTeam from "../components/OurTeam";
import WhyChoose from "../components/WhyChoose";
import Location from "../components/Location";
import CTA from "../components/CTA";

const About = () => {
  return (
    <div>
      <OurTeam />
      <CTA />
      <WhyChoose />
      <Location />
    </div>
  );
};

export default About;
